// extracted by mini-css-extract-plugin
export default {"mainContainer":"SectionController_mainContainer__W6+Vc"};